// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
import { combineReducers } from 'redux';
import { get, post } from '../../shared/http/request';
import { handleApiError } from '../../shared/http/error';
import { toastr } from 'react-redux-toastr';

/** ****************************
 * Recovery Actions redux bundle *
 ***************************** */
// API
const BASE_URL = '/api/recovery-actions';
const COMMAND_URL = '/api/command';

// Actions
const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';
const CREATE_PULL_FORWARD_FULFILLED = 'CREATE_PULL_FORWARD_FULFILLED';
const CREATE_PULL_FORWARD_PENDING = 'CREATE_PULL_FORWARD_PENDING';
const CREATE_PULL_FORWARD_REJECTED = 'CREATE_PULL_FORWARD_REJECTED';
const CREATE_SLIDE_FULFILLED = 'CREATE_SLIDE_FULFILLED';
const CREATE_SLIDE_PENDING = 'CREATE_SLIDE_PENDING';
const CREATE_SLIDE_REJECTED = 'CREATE_SLIDE_REJECTED';
const CREATE_SPECIAL_FULFILLED = 'CREATE_SPECIAL_FULFILLED';
const CREATE_SPECIAL_PENDING = 'CREATE_SPECIAL_PENDING';
const CREATE_SPECIAL_REJECTED = 'CREATE_SPECIAL_REJECTED';
const CREATE_TAP_FULFILLED = 'CREATE_TAP_FULFILLED';
const CREATE_TAP_PENDING = 'CREATE_TAP_PENDING';
const CREATE_TAP_REJECTED = 'CREATE_TAP_REJECTED';
const LOAD_RECOVERY_ACTION_FULFILLED = 'LOAD_RECOVERY_ACTION_FULFILLED';
const LOAD_RECOVERY_ACTION_PENDING = 'LOAD_RECOVERY_ACTION_PENDING';
const LOAD_RECOVERY_ACTION_REJECTED = 'LOAD_RECOVERY_ACTION_REJECTED';
export const ASSIGN_RECOVERY_ACTION_FULFILLED = 'ASSIGN_RECOVERY_ACTION_FULFILLED';
export const ASSIGN_RECOVERY_ACTION_PENDING = 'ASSIGN_RECOVERY_ACTION_PENDING';
export const ASSIGN_RECOVERY_ACTION_REJECTED = 'ASSIGN_RECOVERY_ACTION_REJECTED';
export const CANCEL_RECOVERY_ACTION_FULFILLED = 'CANCEL_RECOVERY_ACTION_FULFILLED';
export const CANCEL_RECOVERY_ACTION_PENDING = 'CANCEL_RECOVERY_ACTION_PENDING';
export const CANCEL_RECOVERY_ACTION_REJECTED = 'CANCEL_RECOVERY_ACTION_REJECTED';
export const EDIT_INSERT_MANIFEST_FULFILLED = 'EDIT_INSERT_MANIFEST_FULFILLED';
export const EDIT_INSERT_MANIFEST_PENDING = 'EDIT_INSERT_MANIFEST_PENDING';
export const EDIT_INSERT_MANIFEST_REJECTED = 'EDIT_INSERT_MANIFEST_REJECTED';
export const EDIT_PULL_FORWARD_FULFILLED = 'EDIT_PULL_FORWARD_FULFILLED';
export const EDIT_PULL_FORWARD_PENDING = 'EDIT_PULL_FORWARD_PENDING';
export const EDIT_PULL_FORWARD_REJECTED = 'EDIT_PULL_FORWARD_REJECTED';
export const EDIT_SLIDE_FULFILLED = 'EDIT_SLIDE_FULFILLED';
export const EDIT_SLIDE_PENDING = 'EDIT_SLIDE_PENDING';
export const EDIT_SLIDE_REJECTED = 'EDIT_SLIDE_REJECTED';
export const EDIT_SPECIAL_FULFILLED = 'EDIT_SPECIAL_FULFILLED';
export const EDIT_SPECIAL_PENDING = 'EDIT_SPECIAL_PENDING';
export const EDIT_SPECIAL_REJECTED = 'EDIT_SPECIAL_REJECTED';
export const EDIT_TAP_FULFILLED = 'EDIT_TAP_FULFILLED';
export const EDIT_TAP_PENDING = 'EDIT_TAP_PENDING';
export const EDIT_TAP_REJECTED = 'EDIT_TAP_REJECTED';
export const MARK_EXECUTED_FULFILLED = 'MARK_EXECUTED_FULFILLED';
export const MARK_EXECUTED_PENDING = 'MARK_EXECUTED_PENDING';
export const MARK_EXECUTED_REJECTED = 'MARK_EXECUTED_REJECTED';

// Reducers
const entities = (state = null, action) => {
    switch (action.type) {
        case LOAD_RECOVERY_ACTION_FULFILLED:
            const recoveryActionById = [
                {
                    [action.recoveryAction.recoveryActionId]: action.recoveryAction,
                },
            ];
            return Object.assign({}, state, ...recoveryActionById);
        case CREATE_PULL_FORWARD_FULFILLED: // some message?
        case CREATE_SLIDE_FULFILLED: // some message?
        case CREATE_SPECIAL_FULFILLED: // some message?
        case CREATE_TAP_FULFILLED: // some message?
        case MARK_EXECUTED_FULFILLED: // some message?
        case CANCEL_RECOVERY_ACTION_FULFILLED: // some message?
        default:
            return state;
    }
};

const isFetching = (state = false, action) => {
    switch (action.type) {
        case LOAD_RECOVERY_ACTION_PENDING:
            return true;
        case LOAD_RECOVERY_ACTION_FULFILLED:
        case LOAD_RECOVERY_ACTION_REJECTED:
            return false;
        default:
            return state;
    }
};

const isPending = (state = false, action) => {
    switch (action.type) {
        case ASSIGN_RECOVERY_ACTION_PENDING:
        case CANCEL_RECOVERY_ACTION_PENDING:
        case CREATE_PULL_FORWARD_PENDING:
        case CREATE_SLIDE_PENDING:
        case CREATE_SPECIAL_PENDING:
        case CREATE_TAP_PENDING:
        case EDIT_PULL_FORWARD_PENDING:
        case EDIT_SLIDE_PENDING:
        case EDIT_SPECIAL_PENDING:
        case EDIT_TAP_PENDING:
        case MARK_EXECUTED_PENDING:
            return true;
        case ASSIGN_RECOVERY_ACTION_FULFILLED:
        case ASSIGN_RECOVERY_ACTION_REJECTED:
        case CANCEL_RECOVERY_ACTION_FULFILLED:
        case CANCEL_RECOVERY_ACTION_REJECTED:
        case CREATE_PULL_FORWARD_FULFILLED:
        case CREATE_PULL_FORWARD_REJECTED:
        case CREATE_SLIDE_FULFILLED:
        case CREATE_SLIDE_REJECTED:
        case CREATE_SPECIAL_FULFILLED:
        case CREATE_SPECIAL_REJECTED:
        case CREATE_TAP_FULFILLED:
        case CREATE_TAP_REJECTED:
        case EDIT_INSERT_MANIFEST_FULFILLED:
        case EDIT_INSERT_MANIFEST_REJECTED:
        case EDIT_PULL_FORWARD_FULFILLED:
        case EDIT_PULL_FORWARD_REJECTED:
        case EDIT_SLIDE_FULFILLED:
        case EDIT_SLIDE_REJECTED:
        case EDIT_SPECIAL_FULFILLED:
        case EDIT_SPECIAL_REJECTED:
        case EDIT_TAP_FULFILLED:
        case EDIT_TAP_REJECTED:
        case LOAD_RECOVERY_ACTION_FULFILLED:
        case LOAD_RECOVERY_ACTION_REJECTED:
        case MARK_EXECUTED_FULFILLED:
        case MARK_EXECUTED_REJECTED:
            return false;
        default:
            return state;
    }
};

const error = (state = null, action) => {
    switch (action.type) {
        case ASSIGN_RECOVERY_ACTION_REJECTED:
        case CANCEL_RECOVERY_ACTION_REJECTED:
        case CREATE_PULL_FORWARD_REJECTED:
        case CREATE_SLIDE_REJECTED:
        case CREATE_SPECIAL_REJECTED:
        case CREATE_TAP_REJECTED:
        case EDIT_INSERT_MANIFEST_REJECTED:
        case EDIT_PULL_FORWARD_REJECTED:
        case EDIT_SLIDE_REJECTED:
        case EDIT_SPECIAL_REJECTED:
        case EDIT_TAP_REJECTED:
        case LOAD_RECOVERY_ACTION_REJECTED:
        case MARK_EXECUTED_REJECTED:
            return true;
        case ASSIGN_RECOVERY_ACTION_FULFILLED:
        case ASSIGN_RECOVERY_ACTION_PENDING:
        case CANCEL_RECOVERY_ACTION_FULFILLED:
        case CANCEL_RECOVERY_ACTION_PENDING:
        case CLEAR_ERROR_MESSAGE:
        case CREATE_PULL_FORWARD_FULFILLED:
        case CREATE_PULL_FORWARD_PENDING:
        case CREATE_SLIDE_FULFILLED:
        case CREATE_SLIDE_PENDING:
        case CREATE_SPECIAL_FULFILLED:
        case CREATE_SPECIAL_PENDING:
        case CREATE_TAP_FULFILLED:
        case CREATE_TAP_PENDING:
        case EDIT_INSERT_MANIFEST_FULFILLED:
        case EDIT_INSERT_MANIFEST_PENDING:
        case EDIT_PULL_FORWARD_FULFILLED:
        case EDIT_PULL_FORWARD_PENDING:
        case EDIT_SLIDE_FULFILLED:
        case EDIT_SLIDE_PENDING:
        case EDIT_SPECIAL_FULFILLED:
        case EDIT_SPECIAL_PENDING:
        case EDIT_TAP_FULFILLED:
        case EDIT_TAP_PENDING:
        case LOAD_RECOVERY_ACTION_FULFILLED:
        case LOAD_RECOVERY_ACTION_PENDING:
        case MARK_EXECUTED_FULFILLED:
        case MARK_EXECUTED_PENDING:
            return false;
        default:
            return state;
    }
};

const errorMessage = (state = null, action) => {
    switch (action.type) {
        case ASSIGN_RECOVERY_ACTION_REJECTED:
        case CANCEL_RECOVERY_ACTION_REJECTED:
        case CREATE_PULL_FORWARD_REJECTED:
        case CREATE_SLIDE_REJECTED:
        case CREATE_SPECIAL_REJECTED:
        case CREATE_TAP_REJECTED:
        case EDIT_INSERT_MANIFEST_REJECTED:
        case EDIT_PULL_FORWARD_REJECTED:
        case EDIT_SLIDE_REJECTED:
        case EDIT_SPECIAL_REJECTED:
        case EDIT_TAP_REJECTED:
        case LOAD_RECOVERY_ACTION_REJECTED:
        case MARK_EXECUTED_REJECTED:
            return action.message;
        case CLEAR_ERROR_MESSAGE: // maybe that's not needed and just include all other actions cases
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    entities,
    isPending,
    isFetching,
    error,
    errorMessage,
});

// Selectors
export const getIsFetching = state => state.entities.recoveryActions.isFetching;
export const getIsPending = state => state.entities.recoveryActions.isPending;
export const getErrorMessage = state => state.entities.recoveryActions.errorMessage;
export const getError = state => state.entities.recoveryActions.error;
export const getRecoveryActionById = (state, id) =>
    state.entities.recoveryActions.entities ? state.entities.recoveryActions.entities[id] : null;

// Action Creators/Thunks
export function createPullForwardRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: CREATE_PULL_FORWARD_PENDING });

        return post(`${COMMAND_URL}/createPullForwardRecoveryAction`, body).then(
            response =>
                setTimeout(
                    () =>
                        dispatch({
                            type: CREATE_PULL_FORWARD_FULFILLED,
                            response,
                        }),
                    1000
                ),
            error =>
                handleApiError(error, dispatch, {
                    type: CREATE_PULL_FORWARD_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function createSlideRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: CREATE_SLIDE_PENDING });

        return post(`${COMMAND_URL}/createSlideRecoveryAction`, body).then(
            response =>
                setTimeout(() => dispatch({ type: CREATE_SLIDE_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: CREATE_SLIDE_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function createSpecialRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: CREATE_SPECIAL_PENDING });

        return post(`${COMMAND_URL}/createSpecialRecoveryAction`, body).then(
            response =>
                setTimeout(() => dispatch({ type: CREATE_SPECIAL_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: CREATE_SPECIAL_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function createTapRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: CREATE_TAP_PENDING });

        return post(`${COMMAND_URL}/createTapRecoveryAction`, body).then(
            response => setTimeout(() => dispatch({ type: CREATE_TAP_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: CREATE_TAP_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function clearErrorMessage() {
    return function(dispatch) {
        dispatch({ type: CLEAR_ERROR_MESSAGE });
        toastr.removeByType('error');
    };
}

export function markExecuted(body) {
    return function(dispatch) {
        dispatch({ type: MARK_EXECUTED_PENDING });

        return post(`${COMMAND_URL}/markRecoveryActionExecuted`, body).then(
            response =>
                setTimeout(() => dispatch({ type: MARK_EXECUTED_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: MARK_EXECUTED_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function loadRecoveryAction(id) {
    return function(dispatch) {
        dispatch({ type: LOAD_RECOVERY_ACTION_PENDING });

        return get(`${BASE_URL}/${id}`).then(
            response =>
                dispatch({
                    type: LOAD_RECOVERY_ACTION_FULFILLED,
                    recoveryAction: response,
                }),
            error =>
                handleApiError(error, dispatch, {
                    type: LOAD_RECOVERY_ACTION_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editSpecialRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: EDIT_SPECIAL_PENDING });

        return post(`${COMMAND_URL}/editSpecialRecoveryAction`, body).then(
            response =>
                setTimeout(() => dispatch({ type: EDIT_SPECIAL_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_SPECIAL_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editTapRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: EDIT_TAP_PENDING });

        return post(`${COMMAND_URL}/editTapRecoveryAction`, body).then(
            response => setTimeout(() => dispatch({ type: EDIT_TAP_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_TAP_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editPullForwardRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: EDIT_PULL_FORWARD_PENDING });

        return post(`${COMMAND_URL}/editPullForwardRecoveryAction`, body).then(
            response =>
                setTimeout(
                    () =>
                        dispatch({
                            type: EDIT_PULL_FORWARD_FULFILLED,
                            response,
                        }),
                    1000
                ),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_PULL_FORWARD_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editSlideRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: EDIT_SLIDE_PENDING });

        return post(`${COMMAND_URL}/editSlideRecoveryAction`, body).then(
            response => setTimeout(() => dispatch({ type: EDIT_SLIDE_FULFILLED, response }), 1000),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_SLIDE_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function editInsertManifestRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: EDIT_INSERT_MANIFEST_PENDING });

        return post(`${COMMAND_URL}/editInsertManifestRecoveryActionCommand`, body).then(
            response =>
                setTimeout(
                    () =>
                        dispatch({
                            type: EDIT_INSERT_MANIFEST_FULFILLED,
                            response,
                        }),
                    1000
                ),
            error =>
                handleApiError(error, dispatch, {
                    type: EDIT_INSERT_MANIFEST_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function cancelRecoveryAction(body) {
    return function(dispatch) {
        dispatch({ type: CANCEL_RECOVERY_ACTION_PENDING });

        return post(`${COMMAND_URL}/cancelRecoveryAction`, body).then(
            response =>
                setTimeout(
                    () =>
                        dispatch({
                            type: CANCEL_RECOVERY_ACTION_FULFILLED,
                            response,
                        }),
                    1000
                ),
            error =>
                handleApiError(error, dispatch, {
                    type: CANCEL_RECOVERY_ACTION_REJECTED,
                    message: error.message,
                })
        );
    };
}

export function assignRecoveryActionToMe(recoveryActionId, abnormalityId) {
    return function(dispatch) {
        dispatch({ type: ASSIGN_RECOVERY_ACTION_PENDING });

        return post(`${COMMAND_URL}/assignRecoveryActionToMeCommand`, {
            recoveryActionId,
            abnormalityId,
        }).then(
            response => {
                setTimeout(
                    () =>
                        dispatch({
                            type: ASSIGN_RECOVERY_ACTION_FULFILLED,
                            response,
                        }),
                    500
                );
                dispatch(loadRecoveryAction(recoveryActionId));
            },
            error =>
                handleApiError(error, dispatch, {
                    type: ASSIGN_RECOVERY_ACTION_REJECTED,
                    message: error.message,
                })
        );
    };
}
